<template>
  <el-dialog
    :title="formData ? '编辑提醒' : '新增提醒'"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    width="880px"
    :close-on-click-modal="false"
    @close="resetForm"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="equipment-form">
      <div class="section-title">设备与报告信息</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="设备名称" prop="device_name">
            <el-input v-model="form.device_name" placeholder="请输入设备名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="科室">
            <department-select v-model="form.department" placeholder="请输入科室" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报告编号">
            <el-input v-model="form.report_no" placeholder="请输入报告编号" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报告日期">
            <el-date-picker v-model="form.report_date" type="date" value-format="yyyy-MM-dd" placeholder="选择报告日期" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="鉴定日期">
            <el-date-picker v-model="form.verify_date" type="date" value-format="yyyy-MM-dd" placeholder="选择鉴定日期" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期(月)">
            <el-input v-model="form.valid_period" placeholder="单位：月" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期至">
            <el-date-picker v-model="form.expire_date" type="date" value-format="yyyy-MM-dd" placeholder="留空则自动推算" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入备注" />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="section-title">PDF 文件（最多 2 个）</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="upload-label">PDF 文件 1</div>
          <el-upload
            action="#"
            :auto-upload="false"
            :show-file-list="true"
            :on-change="handlePdf1Change"
            :on-remove="handlePdf1Remove"
            accept=".pdf"
          >
            <el-button type="primary" icon="el-icon-upload">选择 PDF</el-button>
          </el-upload>
          <div v-if="pdfUrl1" class="pdf-link">
            <el-link type="primary" :href="pdfUrl1" target="_blank" icon="el-icon-document">查看当前 PDF 1</el-link>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="upload-label">PDF 文件 2</div>
          <el-upload
            action="#"
            :auto-upload="false"
            :show-file-list="true"
            :on-change="handlePdf2Change"
            :on-remove="handlePdf2Remove"
            accept=".pdf"
          >
            <el-button type="primary" icon="el-icon-upload">选择 PDF</el-button>
          </el-upload>
          <div v-if="pdfUrl2" class="pdf-link">
            <el-link type="primary" :href="pdfUrl2" target="_blank" icon="el-icon-document">查看当前 PDF 2</el-link>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import pdfReminderApi from '../api/pdf_reminder'

import DepartmentSelect from './DepartmentSelect.vue'

export default {
  name: 'PdfReminderForm',
  components: { DepartmentSelect },
  props: {
    visible: Boolean,
    formData: Object, // 编辑时传入已有记录，新增为 null
  },
  data() {
    return {
      form: this.emptyForm(),
      rules: {
        device_name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
      },
      pdfFile1: null,
      pdfFile2: null,
      submitting: false,
    }
  },
  computed: {
    pdfUrl1() {
      return this.form.pdf_path_1 ? `/media/${this.form.pdf_path_1}` : ''
    },
    pdfUrl2() {
      return this.form.pdf_path_2 ? `/media/${this.form.pdf_path_2}` : ''
    },
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.formData) {
          // 编辑回填（日期字段已是 yyyy-MM-dd 字符串，直接赋值）
          this.form = {
            ...this.emptyForm(),
            id: this.formData.id,
            device_name: this.formData.device_name,
            department: this.formData.department || '',
            report_no: this.formData.report_no || '',
            report_date: this.formData.report_date || '',
            verify_date: this.formData.verify_date || '',
            valid_period: this.formData.valid_period != null ? String(this.formData.valid_period) : '',
            expire_date: this.formData.expire_date || '',
            remark: this.formData.remark || '',
            pdf_path_1: this.formData.pdf_path_1 || '',
            pdf_path_2: this.formData.pdf_path_2 || '',
          }
        } else {
          this.form = this.emptyForm()
        }
      }
    },
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        device_name: '',
        department: '',
        report_no: '',
        report_date: '',
        verify_date: '',
        valid_period: '',
        expire_date: '',
        remark: '',
        pdf_path_1: '',
        pdf_path_2: '',
      }
    },
    handlePdf1Change(file) {
      this.pdfFile1 = file.raw
    },
    handlePdf1Remove() {
      this.pdfFile1 = null
    },
    handlePdf2Change(file) {
      this.pdfFile2 = file.raw
    },
    handlePdf2Remove() {
      this.pdfFile2 = null
    },
    resetForm() {
      if (this.$refs.form) this.$refs.form.resetFields()
      this.pdfFile1 = null
      this.pdfFile2 = null
    },
    async handleSubmit() {
      const valid = await this.$refs.form.validate().catch(() => false)
      if (!valid) return

      this.submitting = true
      const formData = new FormData()
      const textFields = [
        'device_name', 'department', 'report_no',
        'report_date', 'verify_date', 'valid_period',
        'expire_date', 'remark',
      ]
      textFields.forEach((key) => {
        const val = this.form[key]
        if (val !== undefined && val !== null && val !== '') {
          formData.append(key, val)
        }
      })
      if (this.pdfFile1) formData.append('pdf_file_1', this.pdfFile1)
      if (this.pdfFile2) formData.append('pdf_file_2', this.pdfFile2)

      try {
        // 带上保存后的 id 与「是否编辑」：列表页要靠 id 滚动定位到这条记录，
        // 靠 isEdit 决定要不要清空筛选回到默认视图
        let savedId = null
        const isEdit = !!this.form.id
        if (isEdit) {
          const res = await pdfReminderApi.update(this.form.id, formData)
          savedId = (res && res.data && res.data.id) || this.form.id
          this.$message.success('保存成功')
        } else {
          const res = await pdfReminderApi.create(formData)
          savedId = (res && res.data && res.data.id) || null
          this.$message.success('新增成功')
        }
        this.$emit('success', { id: savedId, isEdit })
        this.$emit('update:visible', false)
      } catch (e) {
        const msg =
          e.response && e.response.data
            ? JSON.stringify(e.response.data)
            : '保存失败，请检查后端服务'
        this.$message.error(msg)
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>

<style scoped>
.section-title {
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  color: #303133;
  margin: 20px 0 16px;
  position: relative;
}
.section-title::after {
  content: '';
  display: block;
  width: 48px;
  height: 3px;
  background: #409eff;
  border-radius: 2px;
  margin: 8px auto 0;
}
.upload-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
}
.pdf-link {
  margin-top: 8px;
}
/* 统一输入控件宽度，对齐右侧边框 */
.equipment-form /deep/ .el-input,
.equipment-form /deep/ .el-date-editor,
.equipment-form /deep/ .el-select {
  width: 100% !important;
  display: block;
}
.equipment-form /deep/ .el-date-editor .el-input__inner {
  width: 100% !important;
}
.equipment-form /deep/ .el-input__suffix-inner .el-icon-date {
  display: none;
}
</style>
